import ResultProfileImage from "./component";

export default ResultProfileImage;
